import { useState } from 'react';

const cargos = [
  'Mecânico Industrial',
  'Técnico em Hidráulica',
  'Soldador',
  'Caldeireiro',
  'Eletricista Industrial',
  'Planejador de Manutenção',
  'Técnico de Segurança',
  'Assistente Administrativo',
  'Vendedor Técnico',
  'Outro',
];

const areas = [
  'Mecânica Industrial',
  'Hidráulica Industrial',
  'Soldagem',
  'Caldeiraria',
  'Elétrica Industrial',
  'Planejamento',
  'Segurança do Trabalho',
  'Administrativo',
  'Comercial',
  'Banco de Talentos',
];

const experiencias = [
  'Menos de 1 ano',
  '1 a 2 anos',
  '2 a 5 anos',
  '5 a 10 anos',
  'Mais de 10 anos',
];

const secagemOpcoes = [
  'Prensa de Fardos',
  'Transportadores',
  'Cortadeira',
  'Máquina',
  'Depuradores',
  'Esticadores',
  'Reguladores de Marcha',
  'Substituição de Rolos Secadores',
];

export default function FormularioSection() {
  const [fileName, setFileName] = useState<string>('');
  const [fileError, setFileError] = useState<string>('');
  const [mensagemCount, setMensagemCount] = useState(0);
  const [selectedAreas, setSelectedAreas] = useState<string[]>([]);
  const [selectedSecagem, setSelectedSecagem] = useState<string[]>([]);

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    setFileError('');
    if (file) {
      const allowedTypes = [
        'application/pdf',
        'application/msword',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      ];
      const allowedExts = ['.pdf', '.doc', '.docx'];
      const ext = file.name.slice(file.name.lastIndexOf('.')).toLowerCase();
      if (!allowedTypes.includes(file.type) && !allowedExts.includes(ext)) {
        setFileName('');
        setFileError('Apenas arquivos PDF, DOC ou DOCX são permitidos.');
        e.target.value = '';
        return;
      }
      if (file.size > 5 * 1024 * 1024) {
        setFileName('');
        setFileError('O arquivo deve ter no máximo 5MB.');
        e.target.value = '';
        return;
      }
      setFileName(file.name);
    }
  };

  const toggleArea = (area: string) => {
    setSelectedAreas((prev) =>
      prev.includes(area) ? prev.filter((a) => a !== area) : [...prev, area]
    );
  };

  const toggleSecagem = (opcao: string) => {
    setSelectedSecagem((prev) =>
      prev.includes(opcao) ? prev.filter((o) => o !== opcao) : [...prev, opcao]
    );
  };

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    const form = e.target as HTMLFormElement;
    const formData = new FormData(form);
    const mensagem = formData.get('mensagem') as string;
    if (mensagem && mensagem.length > 500) {
      e.preventDefault();
      alert('A mensagem adicional deve ter no máximo 500 caracteres.');
      return;
    }
    if (!fileName) {
      e.preventDefault();
      setFileError('Por favor, anexe seu currículo.');
      return;
    }
  };

  return (
    <section id="formulario" className="relative bg-gp-graphite-light py-20 md:py-28 overflow-hidden">
      <div className="absolute inset-0 opacity-5">
        <div
          className="absolute inset-0"
          style={{
            backgroundImage: 'radial-gradient(circle at 2px 2px, rgba(232,185,42,0.3) 1px, transparent 0)',
            backgroundSize: '40px 40px',
          }}
        ></div>
      </div>

      <div className="relative z-10 w-full px-4 sm:px-6 lg:px-12">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-16">
            <div className="flex items-center justify-center gap-3 mb-4">
              <div className="w-12 h-[2px] bg-gp-yellow"></div>
              <span className="text-gp-yellow text-sm uppercase tracking-[0.3em] font-medium">Cadastro</span>
              <div className="w-12 h-[2px] bg-gp-yellow"></div>
            </div>
            <h2 className="font-display text-3xl md:text-5xl font-bold text-white uppercase tracking-wider mb-4">
              Envie Seu <span className="text-gp-yellow">Currículo</span>
            </h2>
            <p className="text-gray-400 text-base md:text-lg max-w-2xl mx-auto leading-relaxed">
              Preencha o formulário abaixo com seus dados. Nossa equipe de recrutamento analisará seu perfil e entrará em contato quando houver uma oportunidade compatível.
            </p>
          </div>

          <div className="mb-6 bg-gp-yellow/5 border border-gp-yellow/20 rounded-lg p-4 text-center">
            <p className="text-gray-300 text-sm">
              <i className="ri-mail-send-line text-gp-yellow w-4 h-4 inline-flex items-center justify-center mr-1"></i>
              Os currículos são enviados diretamente para:{" "}
              <span className="text-gp-yellow font-semibold">recrutamento@pilar-aracruz.com.br</span>
            </p>
          </div>

          <form
            id="form-trabalhe-conosco"
            action="enviar_curriculo.php"
            method="POST"
            encType="multipart/form-data"
            onSubmit={handleSubmit}
            className="bg-gp-graphite border border-gp-graphite-lighter rounded-xl p-6 md:p-10 space-y-6"
          >
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label htmlFor="nome" className="block text-gray-300 text-sm font-medium uppercase tracking-wider mb-2">
                  Nome Completo <span className="text-gp-yellow">*</span>
                </label>
                <input
                  type="text"
                  id="nome"
                  name="nome"
                  required
                  placeholder="Seu nome completo"
                  className="w-full bg-gp-graphite-light border border-gp-graphite-lighter rounded-md px-4 py-3 text-white text-sm placeholder-gray-500 focus:outline-none focus:border-gp-yellow transition-colors duration-300"
                />
              </div>

              <div>
                <label htmlFor="telefone" className="block text-gray-300 text-sm font-medium uppercase tracking-wider mb-2">
                  Telefone / WhatsApp <span className="text-gp-yellow">*</span>
                </label>
                <input
                  type="tel"
                  id="telefone"
                  name="telefone"
                  required
                  placeholder="(27) 99999-9999"
                  className="w-full bg-gp-graphite-light border border-gp-graphite-lighter rounded-md px-4 py-3 text-white text-sm placeholder-gray-500 focus:outline-none focus:border-gp-yellow transition-colors duration-300"
                />
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label htmlFor="cpf" className="block text-gray-300 text-sm font-medium uppercase tracking-wider mb-2">
                  CPF <span className="text-gp-yellow">*</span>
                </label>
                <input
                  type="text"
                  id="cpf"
                  name="cpf"
                  required
                  placeholder="000.000.000-00"
                  className="w-full bg-gp-graphite-light border border-gp-graphite-lighter rounded-md px-4 py-3 text-white text-sm placeholder-gray-500 focus:outline-none focus:border-gp-yellow transition-colors duration-300"
                />
              </div>

              <div>
                <label htmlFor="email" className="block text-gray-300 text-sm font-medium uppercase tracking-wider mb-2">
                  E-mail
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  placeholder="seuemail@exemplo.com"
                  className="w-full bg-gp-graphite-light border border-gp-graphite-lighter rounded-md px-4 py-3 text-white text-sm placeholder-gray-500 focus:outline-none focus:border-gp-yellow transition-colors duration-300"
                />
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label htmlFor="cidade_estado" className="block text-gray-300 text-sm font-medium uppercase tracking-wider mb-2">
                  Cidade / Estado
                </label>
                <input
                  type="text"
                  id="cidade_estado"
                  name="cidade_estado"
                  placeholder="Aracruz - ES"
                  className="w-full bg-gp-graphite-light border border-gp-graphite-lighter rounded-md px-4 py-3 text-white text-sm placeholder-gray-500 focus:outline-none focus:border-gp-yellow transition-colors duration-300"
                />
              </div>

              <div>
                <label htmlFor="cargo" className="block text-gray-300 text-sm font-medium uppercase tracking-wider mb-2">
                  Cargo Pretendido <span className="text-gp-yellow">*</span>
                </label>
                <select
                  id="cargo"
                  name="cargo"
                  required
                  className="w-full bg-gp-graphite-light border border-gp-graphite-lighter rounded-md px-4 py-3 text-white text-sm focus:outline-none focus:border-gp-yellow transition-colors duration-300 appearance-none"
                >
                  <option value="" className="bg-gp-graphite-light">Selecione...</option>
                  {cargos.map((c) => (
                    <option key={c} value={c} className="bg-gp-graphite-light">{c}</option>
                  ))}
                </select>
              </div>
            </div>

            <div>
              <label htmlFor="tempo_experiencia" className="block text-gray-300 text-sm font-medium uppercase tracking-wider mb-2">
                Tempo de Experiência
              </label>
              <select
                id="tempo_experiencia"
                name="tempo_experiencia"
                className="w-full bg-gp-graphite-light border border-gp-graphite-lighter rounded-md px-4 py-3 text-white text-sm focus:outline-none focus:border-gp-yellow transition-colors duration-300 appearance-none"
              >
                <option value="" className="bg-gp-graphite-light">Selecione...</option>
                {experiencias.map((e) => (
                  <option key={e} value={e} className="bg-gp-graphite-light">{e}</option>
                ))}
              </select>
            </div>

            <div>
              <label className="block text-gray-300 text-sm font-medium uppercase tracking-wider mb-3">
                Área de Interesse
              </label>
              <p className="text-gray-500 text-xs mb-3">Marque uma ou mais opções de seu interesse.</p>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                {areas.map((area) => (
                  <label
                    key={area}
                    className={`flex items-center gap-3 px-4 py-3 rounded-md border cursor-pointer transition-colors duration-300 ${
                      selectedAreas.includes(area)
                        ? 'border-gp-yellow bg-gp-yellow/10'
                        : 'border-gp-graphite-lighter bg-gp-graphite-light hover:border-gp-yellow/30'
                    }`}
                  >
                    <div
                      className={`w-5 h-5 rounded flex items-center justify-center border transition-colors duration-300 ${
                        selectedAreas.includes(area)
                          ? 'bg-gp-yellow border-gp-yellow'
                          : 'border-gray-500 bg-transparent'
                      }`}
                    >
                      {selectedAreas.includes(area) && (
                        <i className="ri-check-line text-gp-graphite text-xs w-4 h-4 flex items-center justify-center"></i>
                      )}
                    </div>
                    <input
                      type="checkbox"
                      name="area_interesse[]"
                      value={area}
                      checked={selectedAreas.includes(area)}
                      onChange={() => toggleArea(area)}
                      className="hidden"
                    />
                    <span className="text-gray-300 text-sm">{area}</span>
                  </label>
                ))}
              </div>
            </div>

            <div className="pt-2 border-t border-gp-graphite-lighter">
              <label className="block text-gray-300 text-sm font-medium uppercase tracking-wider mb-2">
                Papel e Celulose
              </label>
              <p className="text-gray-500 text-xs mb-3">
                Se possui experiência no setor de Papel e Celulose, marque as áreas de atuação.
              </p>

              <div className="mb-4">
                <span className="text-gp-yellow text-xs font-semibold uppercase tracking-wider mb-2 block">
                  Secagem
                </span>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                  {secagemOpcoes.map((opcao) => (
                    <label
                      key={opcao}
                      className={`flex items-center gap-3 px-4 py-3 rounded-md border cursor-pointer transition-colors duration-300 ${
                        selectedSecagem.includes(opcao)
                          ? 'border-gp-yellow bg-gp-yellow/10'
                          : 'border-gp-graphite-lighter bg-gp-graphite-light hover:border-gp-yellow/30'
                      }`}
                    >
                      <div
                        className={`w-5 h-5 rounded flex items-center justify-center border transition-colors duration-300 ${
                          selectedSecagem.includes(opcao)
                            ? 'bg-gp-yellow border-gp-yellow'
                            : 'border-gray-500 bg-transparent'
                        }`}
                      >
                        {selectedSecagem.includes(opcao) && (
                          <i className="ri-check-line text-gp-graphite text-xs w-4 h-4 flex items-center justify-center"></i>
                        )}
                      </div>
                      <input
                        type="checkbox"
                        name="secagem[]"
                        value={opcao}
                        checked={selectedSecagem.includes(opcao)}
                        onChange={() => toggleSecagem(opcao)}
                        className="hidden"
                      />
                      <span className="text-gray-300 text-sm">{opcao}</span>
                    </label>
                  ))}
                </div>
              </div>
            </div>

            <div>
              <label htmlFor="mensagem" className="block text-gray-300 text-sm font-medium uppercase tracking-wider mb-2">
                Mensagem Adicional
              </label>
              <textarea
                id="mensagem"
                name="mensagem"
                rows={4}
                maxLength={500}
                placeholder="Conte-nos um pouco sobre você, suas habilidades e objetivos profissionais..."
                onChange={(e) => setMensagemCount(e.target.value.length)}
                className="w-full bg-gp-graphite-light border border-gp-graphite-lighter rounded-md px-4 py-3 text-white text-sm placeholder-gray-500 focus:outline-none focus:border-gp-yellow transition-colors duration-300 resize-none"
              ></textarea>
              <div className="flex justify-between mt-1">
                <span className="text-xs text-gray-500">Máximo 500 caracteres</span>
                <span className={`text-xs ${mensagemCount > 500 ? 'text-red-400' : 'text-gray-500'}`}>
                  {mensagemCount}/500
                </span>
              </div>
            </div>

            <div>
              <label className="block text-gray-300 text-sm font-medium uppercase tracking-wider mb-2">
                Upload de Currículo (PDF, DOC, DOCX) <span className="text-gp-yellow">*</span>
              </label>
              <div className={`w-full bg-gp-graphite-light border border-gp-graphite-lighter border-dashed rounded-md px-4 py-6 text-center hover:border-gp-yellow/50 transition-colors duration-300 ${
                fileError ? 'border-red-500/50' : !fileName ? 'border-red-500/30' : ''
              }`}>
                <input
                  type="file"
                  id="curriculo"
                  name="curriculo"
                  accept=".pdf,.doc,.docx"
                  onChange={handleFileChange}
                  className="hidden"
                />
                <label htmlFor="curriculo" className="cursor-pointer flex flex-col items-center gap-2">
                  <i className="ri-upload-cloud-2-line text-gp-yellow text-2xl w-8 h-8 flex items-center justify-center"></i>
                  <span className="text-gray-400 text-sm">
                    {fileName ? fileName : 'Clique para anexar seu currículo'}
                  </span>
                  <span className="text-xs text-gray-500">
                    {fileName ? 'Arquivo selecionado' : 'PDF, DOC ou DOCX até 5MB'}
                  </span>
                </label>
              </div>
              {fileError && (
                <p className="text-red-400 text-xs mt-1">{fileError}</p>
              )}
              {!fileName && !fileError && (
                <p className="text-red-400 text-xs mt-1">Anexo do currículo é obrigatório.</p>
              )}
            </div>

            <div className="pt-4">
              <button
                type="submit"
                className="w-full bg-gp-yellow hover:bg-gp-yellow-dark text-gp-graphite px-8 py-4 rounded-sm font-semibold text-sm uppercase tracking-wider transition-all duration-300 hover:scale-[1.02] whitespace-nowrap flex items-center justify-center gap-3"
              >
                <i className="ri-send-plane-line w-5 h-5 flex items-center justify-center"></i>
                Enviar Currículo
              </button>
            </div>
          </form>
        </div>
      </div>
    </section>
  );
}